


import axios from "axios";

var config = require('../config/appConfig');

export default function callPostApi(urlStr,headers,data) {

    return axios.post(config.serverUrl+urlStr, data,{
        withCredentials: true,
        credentials: "include",
        headers:headers,
      }).then(response => {
          return response.data;       
      }).catch(error => {
        if(error && error.response && error.response.status){
          return error.response.status;
        }
     });
}

